// extracted by mini-css-extract-plugin
export default {"round-icon":"RoundIcon_round-icon__k-c0K"};